export default "__VITE_ASSET__c57e0c8d__"